/* eslint-disable global-require */
module.exports = ['subscriptions.list.cards.modules.member.m1', 'subscriptions.list.cards.card.details.data.m4'];
